<template>
  <div class="has-background-white-bis fixspace">

    <section class="hero is-medium has-background-white-ter is-bold is-hidden-mobile">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h1 class="title is-uppercase" style="font-weight: 900;">
            {{ $t('general.tags') }}
          </h1>
          <h2 class="subtitle py-5 has-text-grey-light">
            TAGS
          </h2>
        </div>
      </div>
    </section>

    <section class="section py-5 has-background-white-ter is-bold is-hidden-tablet">
      <div class="container">
        <h1 class="title is-4 is-uppercase" style="font-weight: 900;">
          {{ $t('general.tags') }}
        </h1>
      </div>
    </section>

    <section class="section">

      <div class="container">
        <hr class="my-6"
            style="border-top:1px solid #000 !important; height:1px !important; width:50px;">
        <p class="is-size-4-desktop is-size-6-mobile has-text-weight-semibold has-text-black mb-5">
          {{ $t('general.popularthisweek') }}
        </p>
      </div>

      <div class="container" v-if="loading">
        <b-skeleton></b-skeleton>
        <b-skeleton></b-skeleton>
        <b-skeleton></b-skeleton>
      </div>

      <div class="container" v-if="!loading">
        <div class="columns is-multiline is-mobile">
          <div class="column" v-for="tag in popular" :key="tag.slug">
            <b-button class="is-radiusless py-6"
                      type="is-black"
                      tag="router-link"
                      :to="{ path: '/tags/' + tag.slug }" expanded>
              {{ tag.trans || tag.name }}
            </b-button>
          </div>
        </div>
      </div>

    </section>

    <section class="section">

      <div class="container">
        <hr class="my-6"
            style="border-top:1px solid #000 !important; height:1px !important; width:50px;">
        <p class="is-size-4-desktop is-size-6-mobile has-text-weight-semibold has-text-black mb-5">
          {{ $t('general.alltimepopular') }}
        </p>
      </div>

      <div class="container" v-if="loading">
        <b-skeleton></b-skeleton>
        <b-skeleton></b-skeleton>
        <b-skeleton></b-skeleton>
      </div>

      <div class="container" v-if="!loading">
        <div class="columns is-multiline is-mobile">
          <div class="column" v-for="tag in alltime" :key="tag.slug">
            <b-button class="is-radiusless py-6"
                      type="is-light"
                      tag="router-link"
                      :to="{ path: '/tags/' + tag.slug }" expanded>
              {{ tag.trans || tag.name }}
            </b-button>
          </div>
        </div>
      </div>

    </section>

  </div>
</template>

<script>
import { getTags } from '@/api/api';

export default {
  name: 'Tags',

  metaInfo() {
    return {
      title: this.$t('title.tags'),
      meta: [
        { name: 'description', vmid: 'description', content: this.$t('about.abouthero1') },
        { property: 'og:title', vmid: 'og:title', content: this.$t('title.tags') },
        { property: 'og:image', vmid: 'og:image', content: 'https://musian.app/assets/open_graph_logo.jpg' },
        { property: 'og:description', vmid: 'og:description', content: this.$t('about.abouthero1') },
      ],
    };
  },

  data() {
    return {
      loading: true,
    };
  },

  created() {
    this.fetchData();

    this.popular = [
      {
        name: '#fictionjunction-feat-lisa',
        slug: 'fictionjunction-feat-lisa',
      },
      {
        name: '#london-philharmonic-orchestra',
        slug: 'london-philharmonic-orchestra',
      },
      {
        name: 'Bach',
        slug: 'bach',
      },
      {
        name: '#バッハ-平均律21番-プレリュード',
        slug: 'バッハ-平均律21番-プレリュード',
      },
    ];

    this.alltime = [
      {
        name: '#睡眠用',
        slug: '睡眠用',
      },
      {
        name: '#dua-lipa-new-rules',
        slug: 'dua-lipa-new-rules',
      },
      {
        name: 'Bach',
        slug: 'bach',
      },
      {
        name: 'Mozart',
        slug: 'mozart',
      },
      {
        name: '#バッハ-平均律21番-プレリュード',
        slug: 'バッハ-平均律21番-プレリュード',
      },
    ];
  },

  methods: {
    fetchData() {
      getTags(null, { headers: { locale: this.$i18n.locale } })
        .then((result) => {
          const { data } = result.data;

          this.keyboard = data.filter((item) => item.type === 'keyboard');
          this.string = data.filter((item) => item.type === 'string');
          this.wind = data.filter((item) => item.type === 'wind');
          this.percussion = data.filter((item) => item.type === 'percussion');
          this.genre = data.filter((item) => item.type === 'genre');

          this.loading = false;
        })
        .catch((err) => { console.error(err); });
    },
  },
};
</script>
